import React from "react";
import PropTypes from "prop-types";
import {Controller} from "react-hook-form";
import ReactHookFormDropdownLetterboxItemTypes from "root/ReactHookForm/ui/ReactHookFormDropdownLetterboxItemTypes";

const DropdownLetterboxItemTypes = ({ validate, control, name, readOnly, options}) =>
{
    /*const fields = { url: '/letterbox/types', keyFieldName: 'letterbox_item_type_id', labelFieldName: 'letterbox_item_type' }

    const [ loading, items ] = useListboxFetch( fields ) ;

    return (
        <Fragment>
            { loading === true && <div className='form-control'><SpinnerDiv/></div> }
            { loading === false && <CommonDropdown items={items} control={control} name={name} rules={rules} placeholder={placeholder} isSearchable={isSearchable} isClearable={isClearable} isMulti={isMulti} readOnly={readOnly} /> }
        </Fragment>
    )*/

    return (
        <Controller
            control={control}
            name={name}
            rules={{ required: true, validate: validate}}
            render={({field: { onChange, value, name, ref }, fieldState: { invalid, isTouched, isDirty, error }, formState,}) => (
                <ReactHookFormDropdownLetterboxItemTypes name={name} onChange={onChange} value={value} inputRef={ref} options={options} readOnly={readOnly}/>
            )}/>
    )
}

export default DropdownLetterboxItemTypes;

DropdownLetterboxItemTypes.propTypes = {
    name: PropTypes.string.isRequired
};
